import React from 'react';
import { CtaButton } from './CtaButton';
import { ProductVisual } from './ProductVisual';
const chips = ['6 Volumes', '5 Bonuses', '139 Breath Cards', '38 Worksheets', '1:1, circles, workshops & retreats'];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'Print it or keep it on a tablet'];
export function Hero() {
  return <section className="paper-ground relative w-full overflow-hidden" data-id="element-118" data-mp="4jvyliyrdmzy">
      <div className="relative z-10 mx-auto max-w-6xl px-5 pb-16 pt-10 sm:pb-24 sm:pt-16" data-id="element-119" data-mp="128pi5dka8x4k">
        <div className="grid items-center gap-10 lg:grid-cols-[1fr_1fr] lg:gap-16" data-id="element-120" data-mp="xaxejma9zmkj">
          <div data-id="element-121" data-mp="s9zzhikkb8n9">
            <p className="text-xs font-medium tracking-wide text-terra-deep" data-id="element-122" data-mp="s9qa9x7cd5im">
              For conscious connected breathwork facilitators
            </p>
            <h1 className="mt-4 font-display text-[36px] leading-[1.1] text-sage sm:text-5xl md:text-[58px]" data-id="element-123" data-mp="3d21uc37gquqd">
              Stop building every breath session{' '}
              <em className="text-terra-deep" data-id="element-124" data-mp="384s78u7jqv5p">from a blank page.</em>
            </h1>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-ink-soft sm:text-lg" data-id="element-125" data-mp="3j9alrqbghebh">
              Breathwork Session Ready is a six-volume library of 139 Breath
              Cards for 1:1 sessions, group circles, workshops, retreats and
              online work &mdash; each with the setup and music map, the exact
              words to say, how to soften or deepen, how to land it and when
              to stop. Not a rigid script: a structure you adapt to your own
              training.
            </p>
            <ul className="mt-7 flex flex-wrap gap-2" data-id="element-126" data-mp="35akitu1ygkf7">
              {chips.map(chip => <li key={chip} className="rounded-full border border-sand-dark bg-cream-dark/70 px-3 py-1.5 text-xs font-medium text-sage" data-id="element-127" data-mp="2qi0mbc9b9b6q">
                  {chip}
                </li>)}
            </ul>

            <div className="mt-8 max-w-md" data-id="element-128" data-mp="2lk8ra9ddd8yb">
              <CtaButton data-id="element-129" data-mp="s1rrim0vq2t8">Get the library</CtaButton>
              <ul className="mt-4 flex flex-wrap gap-x-5 gap-y-2 text-xs text-ink-soft" data-id="element-130" data-mp="s3mb9x0ezovq">
                {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-131" data-mp="n9i71lij9uyc">
                    <span className="h-1.5 w-1.5 rounded-full bg-ochre" data-id="element-132" data-mp="ichy92uaue3j" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>

          <figure data-id="element-133" data-mp="1b0dte347zxy7">
            <ProductVisual eager className="rounded-[24px]" data-id="element-134" data-mp="1ayt7f1vz1nby" />
            <figcaption className="mt-5 text-center" data-id="element-135" data-mp="162ubmt8bd31i">
              <p className="chalk-note text-[17px] leading-snug text-sage sm:text-lg" data-id="element-136" data-mp="112pur23hu6ar">
                You don’t script the breath. You prepare the arc.
              </p>
              <p className="mt-1.5 text-[11px] tracking-[0.14em] text-ink-muted" data-id="element-137" data-mp="x0uywd4c0l4d">
                Prepare · Activate · Release · Integrate · Ground
              </p>
            </figcaption>
          </figure>
        </div>
      </div>
    </section>;
}